<template>
  <div class="main">
    <a-card
      class="lists"
      hoverable
      v-infinite-scroll="loadmore"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <div style="padding: 10px">
        <a-input style="width: 70%" v-model="search"></a-input
        ><a-button style="float: right" type="primary" @click="searchValue"
          >搜索</a-button
        >
      </div>
      <a-spin :spinning="spinning" style="width: 100%">
        <template v-for="(item, index) in lists">
          <div
            :key="index"
            @click="selectRow(index)"
            class="row"
            :class="[currentId == index ? 'active current' : '']"
          >
            <div class="caret success" v-if="item.push > 0"></div>
            <a-row class="title">{{ item.title }}</a-row>
            <a-row class="info" :class="[currentId == index ? 'active' : '']">
              <a-col :span="10" class="pubtime">{{ item.createTime }}</a-col>
              <a-col :span="6" style="font-weight: bold">{{
                item.categoryName
              }}</a-col>
              <a-col :span="8" class="user">{{
                intercept(item.deptName)
              }}</a-col>
            </a-row>
          </div>
        </template>
      </a-spin>
    </a-card>
    <div class="detail">
      <div class="toolbar">
        <!--                <div class="menu edit"><a-icon type="edit" theme="twoTone" twoToneColor="#52c41a" />选用</div>-->
        <!--                <div class="menu" :class="{current : index == 4}" @click="logShow" style="width: 100px"><a-icon type="file-text" />选用记录</div>-->
        <div class="menu" style="width: 100px" @click="share">
          <a-icon type="share-alt" />一键分享
        </div>
        <div
          class="menu"
          style="width: 100px"
          v-if="article.reviewStatus == 100"
        >
          <a-icon type="container" :style="{ color: '#52C41A' }" />
          <span style="color: #52c41a"> 已定稿</span>
        </div>
        <div
          class="menu"
          style="width: 100px"
          @click="getStatus(article.id)"
          v-if="article.reviewStatus == 20"
        >
          <a-icon type="container" :style="{ color: 'red' }" />
          <span style="color: red"> 终审定稿</span>
        </div>
      </div>
      <div class="title">
        <h1>{{ article.title }}</h1>
      </div>
      <div class="info">
        <span>
          <!-- 来源：{{ article.unit }}- -->
          {{ article.reporter }}</span
        >
        <span>来源：{{ article.deptName }}</span
        ><span>作者：{{ article.creatorName }}</span>
        <span>提交时间：{{ article.createTime }}</span>
      </div>
      <div class="content">
        <div v-html="article.content"></div>
        <div style="text-align: right" v-if="aid == 2">
          审核人：{{ article.finalizerName }}
        </div>
      </div>

      <!--<div class="content">-->
      <!--<p><img src="http://ycnumber.cn3x.com.cn/uploads/article/image/20190418/1555564781126117.png" title="1555564781126117.png" alt="JH4{S3TLE4%89M7SX)OX1R9.png"></p>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import moment from 'moment';
import 'whatwg-fetch'
export default {
  name: 'YcNumber',
  directives: { infiniteScroll },
  data() {
    return {
      page: 0,
      spinning: false,
      lists: [],
      currentId: 0,
      showLog: false,
      busy: false,
      article: {},
      index: 0,
      areaLists: [],
      selectAreaId: 1,
      loading: false,
      aid: 0,
      search: ''
    };
  },
  created() {
    let siteInfo = JSON.parse(window.localStorage.getItem('siteinfo'));
    let siteLists = JSON.parse(window.localStorage.getItem('siteLists'));
    siteLists.forEach(element => {
      if (element.siteid == siteInfo.site_id) {
        this.aid = element.deptid;
      }
    });
    this.selectAreaId = siteInfo.area_id;
  },
  methods: {
    moment,
    // loadDetail(id) {
    //   this.$http
    //     .post('http://ycnumber.cn3x.com.cn/index.php/api/detail', {
    //       articleid: id
    //     })
    //     .then(res => {
    //       console.log(res.data);
    //       this.article = res.data.data;
    //     });
    // },
    selectRow(index) {
      this.currentId = index;
      this.article = this.lists[index];
    },
    logShow() {
      this.showLog = !this.showLog;
      this.index = this.showLog ? 4 : 0;
    },
    loadmore() {
      if (!this.loading) {
        this.getLists();
      }
    },
    getLists() {
      if (!this.loading) {
        this.loading = true;
        fetch
          (
            `http://hao.ycrmt.cn/api/open/haofinals/lists?page=${this.page}&aid=${this.aid}&size=20&keywords=${this.search}&reviewStatus=${100}`,
            {
              method: "GET",
              headers: {
                xtoken: 'c1171f848aa8a6963196019320231127'
              },
            }
          )
          .then(response => response.json())
          .then(res => {
            if (res.code == 0) {
              for (let i in res.data) {
                this.lists.push(res.data[i]);
              }
              this.article = this.lists[0];
              this.page++;
              this.loading = false;
            }
          });
      }
    },
    getStatus(id) {
      fetch
        ('http://hao.ycrmt.cn/api/open/haofinals/status', {
          id: id,
        },
          {
            headers: {
              'xtoken': 'c1171f848aa8a6963196019320231127'
            }
          }
        )
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('审核成功');
          }
        });
    },
    share() {
      localStorage.setItem('massArticle', JSON.stringify(this.article));
      let data = {
        id: this.article.id
      }
      fetch('http://hao.ycrmt.cn/api/open/haofinals/share', {
        headers: {
          'xtoken': 'c1171f848aa8a6963196019320231127'
          , 'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(data)
      }).then(response => response.json())
        .then(res => {
          if (res.code === 0) {
            window.open('/Main/Article/Add?type=mass');
          }
        });
    },
    intercept(str) {
      return str.substr(0, 8);
    },
    searchValue() {
      this.page = 0;
      this.lists = [];
      this.getLists();
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.lists {
  width: 360px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.row {
  padding: 5px;
  /*height: 80px;*/
  line-height: 24px;
  position: relative;
  border-bottom: 1px solid #e8e8e8;
}
.current {
  background-color: #409eff;
}

.active,
.active > .pubtime,
.active > .user {
  color: #fff;
}

.row .title {
  padding: 0 5px;
  font-size: 16px;
  line-height: 28px;
}

.row .title i {
  margin-right: 5px;
}

.row .info {
  padding: 0 5px;
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  color: #c0c4cc;
}

.row .info .pubtime {
  text-align: left;
}
.row .info .user {
  text-align: right;
}

.detail {
  position: absolute;
  left: 370px;
  right: 0px;
  top: 0;
  bottom: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
}

.detail .toolbar {
  text-align: right;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.detail .toolbar i {
  margin-right: 5px;
}

.detail .toolbar .menu {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 70px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.detail .toolbar .menu:hover,
.detail .toolbar .current {
  background-color: #eeeeee;
}
.logs {
  background-color: #fff;
  position: absolute;
  z-index: 999;
  width: 280px;
  top: 59px;
  right: 10px;
  bottom: 10px;
  overflow-y: auto;
  transition: all 2s;
  -moz-transition: all 2s; /* Firefox 4 */
  -webkit-transition: all 2s; /* Safari 和 Chrome */
  -o-transition: all 2s; /* Opera */
}
.log-content {
  padding: 10px 0 0 10px;
}

.detail .title {
  line-height: 50px;
  height: 50px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.detail .info span {
  color: #999aa5;
  margin-right: 10px;
}
.detail .content {
  margin-top: 10px;
  font-size: 16px;
  line-height: 28px;
  position: absolute;
  top: 120px;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0 10px;
}
.detail .content img {
  text-align: center;
}

.detail .delete {
  color: #ff6e32;
}

.detail .edit {
  color: #52c41a;
}
.caret {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 6px dashed;
  border-right: 6px dashed;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
}
.success {
  border-top-color: #52c41a;
  border-right-color: #52c41a;
}
</style>

<style>
.content img {
  margin: 0 auto !important;
  width: 400px !important;
}
</style>
